import { HighChartDataBase } from './high-chart-data-base';

export class FunnelHighChartData extends HighChartDataBase {

    private setLineStyles(): void {
        this.chartSeries.forEach((chartSerie, index) => {
            chartSerie.data = chartSerie.data.map(function(p) {
                p.x = p.name;
                return [ p.x*1.0, p.y ];
            });
            if (chartSerie.data.length > 1000) {
                chartSerie.type = null; //Optimize
            }
            switch(index) {
                case 0:
                    chartSerie.dashStyle = "Solid";
                    chartSerie.zIndex = 10; //Place in front
                    break;
                case 1:
                case 4:
                    chartSerie.dashStyle = "LongDash";
                    chartSerie.lineWidth = 1;
                    chartSerie["marker"] = { enabled: false };
                    break;
                case 2:
                case 3:
                    chartSerie.dashStyle = "Dash";
                    chartSerie.lineWidth = 1;
                    chartSerie["marker"] = { enabled: false };
                    break;
                default:
                    chartSerie.dashStyle = "DashDot";
                    chartSerie.zIndex = 1;
                    chartSerie["marker"] = { enabled: false };
                    break;
            }
        });
    }

    private removeNullTooltips(): void {
        let removeAtIndex = [];
        this.tooltips.forEach((tooltip, index) => {
            if (tooltip[0] == null) {
                removeAtIndex.push(index);
            }
        });
        for(let i = removeAtIndex.length - 1; i >= 0; i--) {
            this.tooltips.splice(removeAtIndex[i], 1);
        }
    }

    public getHighChartOptions(): Object {
        this.setLineStyles();
        this.removeNullTooltips();

        let that = this;
        let options = {
            accessability: { enabled: false },
            chart: {
                type: 'line',
                height: this.chartHeight,
                zoomType: 'x',
                resetZoomButton: {
                    position: { x: 0, y: -45 }
                },
                panning: true,
                panKey: 'shift'
            },
            title: { 
                text: this.chartTitle,
                widthAdjust: -150,
                margin: 30
            },
            subtitle: { 
                text: this.chartSubTitle ,
                widthAdjust: -150
            },
            yAxis: this.getYAxis(),
            series: this.chartSeries,
            xAxis: {
                type: "linear",
                title: { 
                    text: this.xAxisTitle 
                },
                min: Number.isNaN(this.xMinValue) ? null : this.xMinValue,
                max: Number.isNaN(this.xMaxValue) ? null : this.xMaxValue
            },
            tooltip: {
                formatter: function() { return that.getDefaultTooltipText(this, false); },
                shared: false,
                useHTML: true
            },
            colors: this.defaultColors,
            legend: {
                enabled: false
            },
            credits: {
                text: this.credits,
                href: this.creditsLink
            },
            boost: {
                useGPUTranslations: true
            },

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: this.chartWidth
                    }
                }]
            },

            exporting: {
                filename: "diagram_" + this.chartTitle
            }
        };
        return options;
    }

    /**
     * Hämta Y-axlar
     */
    private getYAxis() {
        let firstYAxis = this.createYAxis(this.yAxisTitle, this.yAxisTitleColor, this.yMinValue, this.yMaxValue);
        if (!this.hasY2Axis) { 
            //Om det endast finns en y-axis
            return firstYAxis;
        }
        else {
            // Om det finns två y-axlar
            let yAxis = [];
            yAxis.push(firstYAxis);
            let secondYAxis = this.createYAxis(this.y2AxisTitle, this.y2AxisTitleColor, this.y2MinValue, this.y2MaxValue, true);
            yAxis.push(secondYAxis);
            return yAxis;
        }
    }
}
